const resolveAssetSource = source => source;
export default resolveAssetSource;